module.exports = __webpack_public_path__ + "img/gift-12-c1.ff4533e4.png";